import { defineComponent as _defineComponent } from 'vue'
import {
  formatTime,
  formatSecondsToTimeWithMinutes
} from '@/composables/utils';
import { LivescoreResultItem, PreviewEvent } from '../../../../../types/sport';
import { PropType } from 'vue';
import CompetitorIcon from '../../Icons/CompetitorIcon.vue';
import { formattedDate } from '@/composables/utils';
import { GenericOption } from '../../../../../types/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'OddsInfo',
  props: {
  event: {
    type: Object as PropType<PreviewEvent>,
    required: true
  },
  isFullScreen: {
    type: Boolean,
    required: false,
    default: false
  },
  sportId: {
    type: String,
    required: true
  },
  categoryId: {
    type: String,
    required: true
  },
  tournamentId: {
    type: String,
    required: true
  },
  score: {
    type: Array as PropType<LivescoreResultItem[]>,
    required: false
  },
  baseUrl: {
    type: String,
    required: false
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  alignTop: {
    type: Boolean,
    required: false,
    default: false
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, formatTime, formatSecondsToTimeWithMinutes, CompetitorIcon }
}

})